export default __webpack_public_path__ + "static/media/ZZC_7857.583284e9.jpg";